import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { applySeo } from "@/lib/seo";

export default function NotFound() {
  const location = useLocation();

  useEffect(() => {
    applySeo({
      title: "Page introuvable | Easy Car",
      description: "La page demandée n'existe pas ou a été déplacée.",
      robots: "noindex,nofollow",
    });
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-6">
      <div className="text-center max-w-xl">
        <p className="text-7xl md:text-9xl font-black text-red-600">404</p>

        <h1 className="mt-6 text-2xl md:text-3xl font-bold text-gray-900">
          Page introuvable
        </h1>

        <p className="mt-4 text-gray-500">
          La page que vous recherchez n’existe pas ou a été déplacée.
        </p>

        <p className="mt-2 text-sm text-gray-400">
          {location.pathname}
        </p>

        <div className="mt-8 flex flex-col sm:flex-row justify-center gap-3">
          <Link
            to="/"
            className="px-6 py-3 rounded-lg bg-red-600 text-white font-semibold hover:bg-red-700 transition"
          >
            Retour à l’accueil
          </Link>

          <Link
            to="/vehicules"
            className="px-6 py-3 rounded-lg border border-gray-300 text-gray-900 font-semibold hover:bg-gray-50 transition"
          >
            Voir nos véhicules
          </Link>
        </div>
      </div>
    </div>
  );
}
